import styles from './Numbers.module.scss'
import { motion } from "framer-motion"

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Numbers = ({isRus}) => {

    return (
        <motion.section 
        className={styles.main} 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >
        <div className={styles.container}>
        <motion.h3 className={styles.title} variants={titleAnimation}>{isRus ? 'МОИ ОСНОВНЫЕ ДОСТИЖЕНИЯ' : 'MAIN ACHEIVEMENTS'}</motion.h3>
        <motion.p className={styles.subtitle} variants={titleAnimation}>{isRus ? 'С 2005 по 2024 год' : 'From 2005 to 2024'}
        </motion.p>    
        <motion.ul className={styles.list}>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>01</p>
                                <p className={styles.item_text}>{isRus ? 'Создание и управление сетью дистрибуторов Carrier Corporation в России и странах СНГ.' : 'Creating and management of distribution network in Russia and CIS countries.'}
                                </p>
                            </div>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>02</p>
                                <p className={styles.item_text}>{isRus ? 'Достижение лидерских позиций в РФ и рост доли рынка в сегменте с 18% в 2006 до 75% в 2023 году' : 'Achieving leadership positions in Russia with 75% segment shares growth in 2023 vs 13% in 2006'}
                                </p>
                            </div>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>03</p>
                                <p className={styles.item_text}>{isRus ? 'В 2014 году был отмечен Дипломом за рекордные продажи в истории компании (23$ Млн – продажа оборудования для компании Магнит).' : 'Recorded 24$ Mln sales in 2013 (supply technological equipment to “MAGNIT”)'}</p>
                            </div>
                    </motion.li>
                </motion.ul>
        </div>   
    </motion.section>
    )
}

export default Numbers